import { useFormik } from "formik"
import { useCallback, useEffect, useState } from "react"
import { Helmet } from "react-helmet"
import toast from "react-hot-toast"
import { useHistory } from "react-router"
import { useParams } from 'react-router-dom'
import { useGetLoginContato } from "../../../data/api/login-contato/login-contato"
import { AtualizarContatoModel } from "../../../model/api/Atualizar/cadastrar-contato-model"
import { CadastrarContatoModel } from "../../../model/api/Cadastrar/cadastrar-contato-model"
import { useSessaoAtual } from "../../../services/providers/sessao-atual-provider/sessao-atual-provider"
import { BaixasStorageKeys, useBaixasStorage } from "../../../services/use-cases/baixas-storage"
import { maskCnpjCpf, maskPhone } from "../../../utils/masks"
import { stringNumeros } from "../../../utils/string-numeros"
import { Nav } from "../../components/nav"
import { CircularLoading } from "../../components/utils/circular-loading"
import './adicionar-contato.css'

export const AdicionarContatoPage = () => {
    const { getRegister } = useBaixasStorage()
    const { getLoginContato, carregando: getLoginContatoCarregando } = useGetLoginContato()
    const { CadastrarContato, AtualizarContato, carregando: useSessaoAtualCarregando } = useSessaoAtual();
    const [data, setData] = useState<CadastrarContatoModel>(
        new CadastrarContatoModel()
    );
    const { id } = useParams<any>()
    const history = useHistory()
    const dataRes = getRegister(BaixasStorageKeys.dataRepresentante)
    const dadosParam = id !== undefined && id.split("|")
    const [loading, setLoading] = useState<boolean>(false)
    const idUser = dadosParam.length !== 0 ? dadosParam[0] : ''
    const email = dadosParam.length !== 0 ? dadosParam[1] : ''
    const telefone = dadosParam.length !== 0 ? dadosParam[2] : ''

    const carregando = getLoginContatoCarregando || useSessaoAtualCarregando

    const getDadosContato = useCallback(async (email: string, telefone: string) => {
        const res = await getLoginContato(email, telefone)
        if (res.erro) {
            throw res.erro
        }
        return res.resultado?.data as CadastrarContatoModel
    }, [getLoginContato])


    useEffect(() => {
        if (id !== undefined) {
            (async () => {
                try {
                    setLoading(true)
                    const res = await getDadosContato(email, telefone)
                    setData(res)
                    setLoading(false)
                } catch (e: any) {
                    toast.error(e.message)
                    setLoading(false)
                }
            })()
        }
    }, [email, getDadosContato, id, telefone])

    const formik = useFormik({
        initialValues: {
            ...data,
            telefone: maskPhone(data.telefone),
            cpfcnpj: maskCnpjCpf(data.cpfcnpj)
        },
        enableReinitialize: true,
        onSubmit: values => {
            id === undefined ? EfetuarCadastro({
                email: values.email,
                telefone: stringNumeros(values.telefone),
                nome: values.nome,
                nomeEmpresa: values.nomeEmpresa,
                cpfcnpj: stringNumeros(values.cpfcnpj),
                responsavelId: dataRes.id,
                dataVisita: new Date(),
                observacao: values.observacao,
                negociacao: values.negociacao
            }) :
                EfetuarAtualizacao({
                    id: idUser,
                    email: values.email,
                    telefone: stringNumeros(values.telefone),
                    nome: values.nome,
                    nomeEmpresa: values.nomeEmpresa,
                    cpfcnpj: stringNumeros(values.cpfcnpj),
                    responsavelId: dataRes.id,
                    dataVisita: values.dataVisita,
                    observacao: values.observacao,
                    negociacao: values.negociacao
                })
        }
    })

    const EfetuarCadastro = async (model: CadastrarContatoModel) => {
        try {
            await CadastrarContato(model)
            toast.success('Contato cadastrado com sucesso')
            history.push('/representante/clientes')
        } catch (e: any) {
            toast.error(e.message)
        }
    }

    const EfetuarAtualizacao = async (model: AtualizarContatoModel) => {
        try {
            await AtualizarContato(model)
            toast.success('Contato atualizado com sucesso')
            history.push('/representante/clientes')
        } catch (e: any) {
            toast.error(e.message)
        }
    }

    function autoResize() {
        let objTextArea: any = document.getElementById('txtTextArea');
        while (objTextArea.scrollHeight > objTextArea.offsetHeight) {
            objTextArea.rows += 1;
        }
    }

    return (
        <div className="adicionarContato">
            <Helmet>
                <title>{`${dadosParam ? 'Editar contato' : 'Adicionar contato'} - Saurus AutoCom`}</title>
            </Helmet>
            <Nav btnVoltarShow voltar="/representante/clientes" title={dadosParam ? 'Editar contato' : 'Adicionar contato'} />
            {!loading && (
                <div className="container mt-4 mb-4">
                    {carregando && <CircularLoading tipo="FULLSIZED" />}
                    <form onSubmit={formik.handleSubmit}>
                        <div className="row mb-5">
                            <div className="col-12 col-lg-6">
                                <div className="mb-3">
                                    <span className="form-label">Nome</span>
                                    <input {...formik.getFieldProps('nome')} placeholder="Nome completo" autoComplete="off" aria-autocomplete="none" required name="nome" type="text" className="form-control mt-1" />
                                </div>
                            </div>
                            <div className="col-12 col-lg-6">
                                <div className="mb-3">
                                    <span className="form-label">Email</span>
                                    <input {...formik.getFieldProps('email')} type="email" inputMode="email" autoComplete="new-password" className="form-control mt-1" required={formik.values.telefone.length === 0} name="email" placeholder="@exemplo.com" />
                                </div>
                            </div>
                            <div className="col-12 col-lg-6">
                                <div className="mb-3">
                                    <span className="form-label">Telefone</span>
                                    <input {...formik.getFieldProps('telefone')} inputMode="numeric" onChange={e => formik.setFieldValue('telefone', maskPhone(e.target.value))} autoComplete="new-password" placeholder="Insira seu número" required={formik.values.email.length === 0} type="text" name="telefone" className="form-control mt-1" />
                                </div>
                            </div>
                            <div className="col-12 col-lg-6">
                                <div className="mb-3">
                                    <span className="form-label">CPF/CNPJ</span>
                                    <input placeholder="(Opcional)" {...formik.getFieldProps('cpfcnpj')} onChange={e => formik.setFieldValue('cpfcnpj', maskCnpjCpf(e.target.value))} inputMode="numeric" autoComplete="new-password" title="CPF/CNPJ" type="text" name="cpfcnpj" className="form-control mt-1" />
                                </div>
                            </div>
                            <div className="col-12 col-lg-6">
                                <div className="mb-3">
                                    <span className="form-label">Cidade/Estado</span>
                                    <input placeholder="SP" {...formik.getFieldProps('endereco')} onChange={e => formik.setFieldValue('endereco', (e.target.value))} inputMode="text" autoComplete="new-password" title="Cidade/Estado" type="text" name="endereco" className="form-control mt-1" />
                                </div>
                            </div>
                            <div className="col-12 col-lg-6">
                                <div className="mb-3">
                                    <span className="form-label">Nome da Empresa</span>
                                    <input {...formik.getFieldProps('nomeEmpresa')} placeholder="(Opcional)" autoComplete="new-password" type="text" name="nomeEmpresa" className="form-control mt-1" />
                                </div>
                            </div>
                            <div className="col-12 col-lg-6">
                                <div className="mb-3">
                                    <span className="form-label">Observação</span>
                                    <textarea {...formik.getFieldProps('observacao')} style={{ resize: 'none', overflow: 'none' }} onKeyDown={autoResize} id="txtTextArea" placeholder="(Opcional)" autoComplete="new-password" name="observacao" className="form-control form-area mt-1" />
                                </div>
                            </div>
                            <div className="col-12 col-lg-6">
                                <div className="">
                                    <span className="form-label">Negociação</span>
                                    <textarea {...formik.getFieldProps('negociacao')} placeholder="(Opcional)" autoComplete="new-password" name="negociacao" className="form-control mt-1" />
                                </div>
                            </div>
                        </div>
                        <button className="btn btn-primary w-100 mb-3" type="submit">{dadosParam ? 'Continuar' : 'Cadastrar'}</button>
                    </form>
                </div>
            )}
        </div>
    )
}